import { HandshakeIcon, Paragraph, PrescriptionIcon } from '@quickmd-llc/design-system'
import type { MedicationStaffApiOutContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'
import { MedicationDetailView } from './MedicationDetailView'

function RxIcon() {
  return (
    <div className='flex h-20 w-20 items-center justify-center rounded-full bg-neutral-20'>
      <PrescriptionIcon iconSize='xxl' className='text-text-dark' />
    </div>
  )
}

function HandsIcon() {
  return (
    <div className='flex h-20 w-20 items-center justify-center rounded-full bg-neutral-20'>
      <HandshakeIcon iconSize='xxl' className='text-text-dark' />
    </div>
  )
}

interface MedicationDetailPanelProps {
  hasAnyMedications: boolean
  hasPartners: boolean
  selectedMedication: MedicationStaffApiOutContract | null
  onDelete: (medication: MedicationStaffApiOutContract) => void
}

export function MedicationDetailPanel({
  hasAnyMedications,
  hasPartners,
  selectedMedication,
  onDelete,
}: MedicationDetailPanelProps) {
  if (selectedMedication) {
    return <MedicationDetailView medication={selectedMedication} onDelete={onDelete} />
  }

  return (
    <div className='flex h-full flex-col items-center justify-center gap-sp-2 rounded-large border border-border-medium bg-white'>
      {hasPartners ?
        <RxIcon />
      : <HandsIcon />}
      <Paragraph size='md' className='text-text-light'>
        {!hasPartners ?
          'Start by adding fulfillment partners'
        : hasAnyMedications ?
          'Select a medication to view details'
        : 'Begin adding medications'}
      </Paragraph>
    </div>
  )
}
